// Pins strip for active operator chat

import React from 'react';
import { formatOperatorMessageTime } from '../../services/operatorChatService';

export default function OperatorChatPinsBar({ pins, onJump, onUnpin }) {
    if (!pins || pins.length === 0) return null;

    return (
        <div className="op-msg-pins" aria-label="Pinned messages">
            <span className="op-msg-pins__label">Pinned</span>
            <ul className="op-msg-pins__list">
                {pins.map((msg) => (
                    <li key={msg.id}>
                        <button
                            type="button"
                            className="op-msg-pin-chip"
                            onClick={() => onJump?.(msg.id)}
                            title={msg.bodyText || msg.attachments?.[0]?.fileName || 'Pinned message'}
                        >
                            <span className="op-msg-pin-chip__text">
                                {msg.bodyText
                                    ? msg.bodyText.slice(0, 72)
                                    : msg.attachments?.[0]?.fileName || 'Attachment'}
                            </span>
                            <span className="op-msg-pin-chip__meta">
                                {msg.fromName || 'Operator'}
                                {msg.pinnedAt ? ` · ${formatOperatorMessageTime(msg.pinnedAt)}` : ''}
                            </span>
                        </button>
                        <button
                            type="button"
                            className="op-msg-pin-unpin"
                            aria-label="Unpin message"
                            onClick={() => onUnpin?.(msg.id)}
                        >
                            Unpin
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
